var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa-kit fa-regular-file-lines-pen"})]),_vm._v("\n  This post is a Draft\n")])}]

export { render, staticRenderFns }